import { render, staticRenderFns } from "./CamaraAlerta.vue?vue&type=template&id=0ced5e12&"
import script from "./CamaraAlerta.vue?vue&type=script&lang=ts&"
export * from "./CamaraAlerta.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraAlerta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0ced5e12', component.options)
    } else {
      api.reload('0ced5e12', component.options)
    }
    module.hot.accept("./CamaraAlerta.vue?vue&type=template&id=0ced5e12&", function () {
      api.rerender('0ced5e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alerta/CamaraAlerta.vue"
export default component.exports